module.exports = new __parcel__URL__("logo_cutout.9ca288c1.png").toString();